import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { token } = useAuth();

  // ✅ 没 token 就跳前端 /login，不是 API 地址！
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
